import { sellerApiClient } from './sellerApiClient';
import { TokenResponse } from '@api/Responses/TokenResponse';

export const registration = async ({ email, token }: {
  email: string,
  token: string,
}): Promise<void> => {
  const response = await sellerApiClient.post<void>(
    "/v1/registration/send",
    { email },
    {
      headers: {
        "X-Captcha-Token": token,
      },
    },
  );

  return response.data;
};

export const signUp = async ({ email, password, countryCode, ticket, randstr, promoId }: {
  email: string,
  password: string,
  countryCode: string,
  randstr: string,
  ticket: string;
  promoId?: string,
}): Promise<void> => {
  const response = await sellerApiClient.post<void>(
    "/v1/registration/sign-up/link",
    { email, password, countryCode, promoId },
    {
      headers: {
        "X-Captcha-Ticket": ticket,
        "X-Captcha-Randstr": randstr,
      },
    },
  );

  return response.data;
};

export type updateUserResponse = {
  skipSmsVerification: boolean;
}

export const updateUserInfo = async (data: {
  phone?: string,
  name: string,
}): Promise<updateUserResponse> => {
  const response = await sellerApiClient.post<updateUserResponse>(
    "/v1/accounts/me/info",
    data,
  );

  return response.data;
};

export const verifyPhone = async ({ code }: {
  code: string,
}): Promise<void> => {
  const response = await sellerApiClient.post<void>(
    "/v1/accounts/verify-pin",
    { pinCode: code },
  );

  return response.data;
};

export const sendCode = async (phone: string): Promise<void> => {
  const response = await sellerApiClient.post<void>(
    `/v1/accounts/send-pin`,
    { phone },
  );

  return response.data;
};

export const verifySecurityStamp = async (securityStamp: string): Promise<void> => {
  const response = await sellerApiClient.post<void>(
    `/v1/registration/verify/security-stamp`,
    { securityStamp },
  );

  return response.data;
};

interface PromoData {
  id: string,
  name: string,
  isActive: boolean,
  maxAccounts: number,
  promoType?: string,
}

export const getPromo = async (
  id?: string,
  referrer?: string,
): Promise<PromoData> => {
  const response = await sellerApiClient.get<PromoData>(
    "/v1/promos",
    { params: id ? { Id: id } : { Referrer: referrer } },
  );
  return response.data;
};

export type TOzonInfoResponse = {
  email: string;
  phone: string;
};

export const getOzonInfo = async (key: string): Promise<TOzonInfoResponse> => {
  const response = await sellerApiClient.get<TOzonInfoResponse>(`/v1/registration/ozon/info?key=${key}`);
  return response.data;
};

export type TOzonSendPinRequest = {
  key: string;
  phone: string;
};

export type ozonSendCodeResponse = {
  skipSmsVerification: boolean;
}

export const ozonSendCode = async (data: TOzonSendPinRequest): Promise<ozonSendCodeResponse> => {
  const response = await sellerApiClient.post<ozonSendCodeResponse>('/v1/registration/ozon/send-pin', data);
  return response.data;
};

export type TOzonVerifyPinRequest = {
  key: string;
  code: string;
};

export const ozonVerifyCode = async (data: TOzonVerifyPinRequest): Promise<void> => {
  const response = await sellerApiClient.post<void>('/v1/registration/ozon/verify-pin', data);
  return response.data;
};

export type TOzonSignUpByKeyRequest = {
  clientId: string;
  countryCode: string;
  key: string;
  name: string;
  password: string;
};

export const ozonSignUpByKey = async (data: TOzonSignUpByKeyRequest): Promise<TokenResponse> => {
  const response = await sellerApiClient.post<TokenResponse>('/v1/registration/ozon/by-key', data);
  return response.data;
};

export type TOzonAddApiKeyRequest = {
  ozonApiKey: string;
};

export const ozonAddApiKey = async (data: TOzonAddApiKeyRequest): Promise<void> => {
  const response = await sellerApiClient.post<void>('/v1/accounts/confirm-ozon', data);
  return response.data;
};
